module.exports = __webpack_public_path__ + "static/blender-ad752e7abf682f35b298ffa03e81dfbd.png";